import React, { Fragment } from 'react'
// Loader overlay for payment processing
const Loader: React.FC = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.35)',
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'opacity 0.2s'
    }}
  >
    <div
      style={{
        background: 'rgba(255,255,255,0.85)',
        borderRadius: '16px',
        padding: '32px 48px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px'
      }}
    >
      <i className="fas fa-spinner fa-spin fa-3x" style={{ color: '#0F094F' }}></i>
      <span style={{ color: '#333', fontWeight: 500, fontSize: 18 }}>Переход к оплате...</span>
    </div>
  </div>
)
import AppBackBtn from '../../components/ui/AppBackBtn'
import AppWrapper from '../../components/ui/AppWrapper/AppWrapper'
import AppWrapperTitle from '../../components/ui/AppWrapperTitle'
import AppWrapperSubtitle from '../../components/ui/AppWrapperSubtitle'
import AppWrapperList from '../../components/ui/AppWrapperList/AppWrapperList'
import ListCard from '../../components/ui/ListCard/ListCard'
import './PaymentView.css'
import { Link } from 'react-router-dom'
import LinkCard from '../../components/ui/LinkCard/LinkCard'
import { User, UserContext, UserContextProps } from '../../context/UserContext'
import { api, participantApiV1 } from '../../api'
import { Listbox, Transition } from '@headlessui/react'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

interface Step {
  id: number
  icon: string
}

enum PaymentForm {
  Month = 1,
  Manual
}

const steps: Step[] = [
  {
    id: 1,
    icon: 'fas fa-check-square'
  },
  {
    id: 2,
    icon: 'fas fa-calendar'
  },
  { id: 3, icon: 'fas fa-wallet' },
  { id: 4, icon: 'fas fa-check-circle' }
]

interface PaymentViewState {
  currentStep: number
  additional: boolean
  periods: any[]
  chosenPeriod: any
  chosenPaymentForm: PaymentForm
  amount: number | string
  amountError: string
  comment: string
  selectedPeriod: null | 'month' | 'quarter' | 'year'
  isProcessing: boolean
}

const months = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь'
]

const MAX_AMOUNT = 1_000_000 // amount in rub
const MIN_AMOUNT = 1 // amount in rub
let BASE_AMOUNT = 821 // amount in kopecks

function genPeriods() {
  const yearNow = new Date().getFullYear() // let monthNow = new Date().getMonth();
  const availableMonths = months.slice(0, 1000)

  return [
    // allYearOption,
    ...availableMonths.map((_x, index) => {
      return {
        date: `01.${index}.${yearNow}`,
        title: `За ${_x.toLowerCase()} ${yearNow} года`,
        year: yearNow,
        amount: BASE_AMOUNT, // in kopecks
        month: months.indexOf(_x) + 1,
        month_start: null,
        month_end: null
      }
    })
  ]
}

const withUserContext = (WrappedComponent: React.ComponentType<any>) => {
  return (props: any) => (
    <UserContext.Consumer>
      {(context) => <WrappedComponent {...props} userContext={context} />}
    </UserContext.Consumer>
  )
}

class PaymentView extends React.Component<{ userContext: UserContextProps }, PaymentViewState> {
  constructor(props: { userContext: UserContextProps }) {
    super(props)
    this.state = {
      periods: genPeriods(),
      currentStep: 1,
      additional:
        window.location.hostname !== 'er-contributions.ru' &&
        window.location.hostname !== 'www.er-contributions.ru' &&
        window.location.hostname !== 'v2.er-contributions.ru',
      chosenPeriod: undefined,
      chosenPaymentForm: PaymentForm.Month,
      amount: '',
      amountError: '',
      comment: '',
      selectedPeriod: null,
      isProcessing: false
    }
    this.periodOnSelect = this.periodOnSelect.bind(this)
    this.methodOnSelect = this.methodOnSelect.bind(this)
    this.backStep = this.backStep.bind(this)
    this.validateAmount = this.validateAmount.bind(this)
  }

  componentDidMount() {
    this.waitForUserAndFetchBaseAmount()
  }

  waitForUserAndFetchBaseAmount = () => {
    const checkUser = () => {
      const user = this.props.userContext?.currentUser as User
      if (user) {
        this.fetchBaseAmount(user.ro_id)
      } else {
        setTimeout(checkUser, 300)
      }
    }

    checkUser()
  }

  fetchBaseAmount = (regionId: number) => {
    api
      .get(`/membership-fees/${regionId}`)
      .then((response) => {
        BASE_AMOUNT = response.data.amount
        this.setState({ periods: genPeriods() })
      })
      .catch((error) => {
        console.error('Ошибка при загрузке базовой суммы: ' + error.message)
      })
  }

  periodOnSelect = (_period: any, _user: any) => {
    this.setState((prevState) => ({
      currentStep: prevState.currentStep + 1,
      chosenPeriod: _period
    }))
  }

  methodOnSelect = (isQr: boolean) => {
    if (this.state.isProcessing) return

    const url = '/participants/payments/new_and_work_with_sber_immediately'

    if (!confirm(`Вы уверены, что хотите совершить платеж ${isQr ? 'по СБП' : 'картой'}?`)) return

    this.setState({ isProcessing: true })

    participantApiV1
      .post(url, {
        amount: this.state.chosenPeriod?.amount,
        month: this.state.chosenPeriod?.month,
        month_start: this.state.chosenPeriod?.month_start,
        month_end: this.state.chosenPeriod?.month_end,
        year: this.state.chosenPeriod?.year,
        use_qr: isQr,
        is_deposit: Boolean(this.state.chosenPeriod?.is_deposit),
        comment: this.state.chosenPeriod?.comment || ''
      })
      .then((resp) => {
        const { data } = resp.data
        console.log('Payment response:', resp)

        if (data.nspk_url) {
          window.location.href = data.nspk_url
          return
        }

        if (data.form_url) {
          window.location.href = data.form_url
          return
        }
      })
      .catch((err) => {
        let message = 'Неизвестная ошибка'

        if (err?.response?.data) {
          const data = err.response.data

          // Проверяем новый формат ошибки
          if (data.status === 'error' && data.error) {
            message = data.error
          }
          // Проверяем старый формат ошибки
          else if (data['_embedded']?.['errors']?.[0]?.message) {
            message = data['_embedded']['errors'][0].message
            message = message.replace('Internal Server Error: ', '')
          }
        }

        toast.error('Ошибка при создании платежа: ' + message)
      })
      .finally(() => {
        this.setState({ isProcessing: false })
      })
  }

  backStep = () => {
    if (this.state.currentStep === 1) return
    this.setState((prevState) => ({ currentStep: prevState.currentStep - 1 }))
  }

  classNames = (...classes: string[]) => {
    return classes.filter(Boolean).join(' ')
  }

  setChosenPaymentForm = (form: PaymentForm) => {
    this.setState((prevState) => ({
      currentStep: prevState.currentStep + 1,
      chosenPaymentForm: form
    }))
  }

  prepareManualPayment = () => {
    this.setState((prevState) => ({
      chosenPeriod: {
        amount: Number(prevState.amount) * 100, // in kopecks
        month_start: 1,
        month_end: 12,
        month: null,
        year: new Date().getFullYear(),
        comment: prevState.comment,
        is_deposit: true
      }
    }))
  }

  prepareQuarterPayment = (start: number, end: number) => {
    this.setState((prevState) => ({
      chosenPeriod: {
        amount: 3 * BASE_AMOUNT, // in kopecks
        month_start: start,
        month_end: end,
        month: null,
        year: new Date().getFullYear()
      },
      currentStep: prevState.currentStep + 1
    }))
  }

  prepareYearPayment = (year: number = 2025) => {
    this.setState((prevState) => ({
      chosenPeriod: {
        amount: 12 * BASE_AMOUNT, // in kopecks
        month_start: 1,
        month_end: 12,
        year: year
      },
      currentStep: prevState.currentStep + 1
    }))
  }

  validateAmount = () => {
    if (Number(this.state.amount) < MIN_AMOUNT) {
      this.setState({
        amountError: `Сумма должна быть от ${MIN_AMOUNT?.toLocaleString('ru-RU')} до ${MAX_AMOUNT?.toLocaleString('ru-RU')} рублей`
      })
    } else if (Number(this.state.amount) > MAX_AMOUNT) {
      const errorMessage = `
        В соответствии с восьмым пунктом тридцатой статьи  Федерального закона от 11.07.2001 N 95-ФЗ (ред. от 24.07.2023) «О политических партиях» сумма пожертвований, полученных политической партией, в том числе ее региональными отделениями, от одного физического лица в течение календарного года, не должна превышать четыре миллиона триста тридцать тысяч рублей.
        Сумма одной транзакции не может превышать десять тысяч рублей в соответствии с внутренним регламентом Единой цифровой платформы «Сбор членских взносов» Партии «ЕДИНАЯ РОССИЯ»
      `
      this.setState({ amountError: errorMessage })
    } else {
      this.setState({ amountError: '', currentStep: 3 }, () => {
        this.prepareManualPayment()
      })
    }
  }

  handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    if (value.match(/\./g)) {
      const [, decimal] = value.split('.')

      if (decimal?.length > 2) {
        return
      }
    }
    this.setState({ amount: value })
  }

  handleCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ comment: e.target.value })
  }

  setSelectedPeriod = (period: null | 'month' | 'quarter' | 'year') => {
    this.setState({ selectedPeriod: period })
  }

  getBreadcrumbs() {
    const { currentStep, chosenPaymentForm, selectedPeriod, chosenPeriod } = this.state
    const breadcrumbs = []

    if (currentStep > 1 && chosenPaymentForm === PaymentForm.Month) {
      breadcrumbs.push({ label: 'ВЗНОС ЗА УСТАНОВЛЕННЫЙ ПЕРИОД' })

      if (selectedPeriod) {
        let periodLabel = ''
        if (selectedPeriod === 'month') periodLabel = 'ЗА 1 МЕС.'
        else if (selectedPeriod === 'quarter') periodLabel = 'ЗА КВАРТАЛ'
        else if (selectedPeriod === 'year') periodLabel = 'ЗА ГОД'
        breadcrumbs.push({ label: periodLabel })
      }

      if (currentStep === 3) {
        let periodLabel = ''
        if (selectedPeriod === 'month')
          periodLabel = `${months[chosenPeriod.month - 1]} ${chosenPeriod.year}`
        else if (selectedPeriod === 'quarter')
          periodLabel = `${chosenPeriod.month_end === 3 ? '1 квартал' : ''}${chosenPeriod.month_end === 6 ? '2 квартал' : ''}${chosenPeriod.month_end === 9 ? '3 квартал' : ''}${chosenPeriod.month_end === 12 ? '4 квартал' : ''}`
        else if (selectedPeriod === 'year') periodLabel = `ЗА ${chosenPeriod.year} ГОД`
        breadcrumbs.push({ label: periodLabel })
      }
    }

    return breadcrumbs
  }

  render() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const me = this
    const breadcrumbs = this.getBreadcrumbs()

    return (
      <UserContext.Consumer>
        {(user) => (
          <>
            {this.state.isProcessing && <Loader />}
            <AppBackBtn to="/home" />
            <AppWrapper className="bg-appLightGray h-[80%] gap-y-4">
              <AppWrapperTitle>Внесение членского взноса</AppWrapperTitle>

              <div className="flex flex-row items-center justify-center w-full flex-nowrap gap-x-2">
                {this.state.currentStep > 1 && (
                  <button
                    onClick={this.backStep}
                    type="button"
                    className="border-2 border-[#C9C8D6] px-4 py-3 rounded-full text-[#8C89AC] text-xs font-medium cursor-pointer"
                  >
                    <i className="fas fa-chevron-left"></i>
                  </button>
                )}
                {steps.map((step, index) => (
                  <React.Fragment key={step.id}>
                    <div
                      className={`circle ${this.state.currentStep === step.id ? 'active' : ''} ${this.state.currentStep > step.id ? 'success' : ''}`}
                    >
                      <i className={step.icon}></i>
                    </div>
                    {index !== steps.length - 1 && (
                      <div className="divider">
                        <i className="fas fa-minus"></i>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {this.state.currentStep > 1 && this.state.chosenPaymentForm === PaymentForm.Month && (
                <ol
                  role="list"
                  className="flex flex-row flex-wrap items-center justify-center w-full uppercase cursor-default gap-x-2"
                >
                  {breadcrumbs.map((breadcrumb, index) => (
                    <li key={index}>
                      <div className="flex items-center">
                        <span className="mr-2 text-sm font-medium text-gray-500 uppercase cursor-default">
                          {breadcrumb.label}
                        </span>
                        {index < breadcrumbs.length - 1 && (
                          <i className="flex-shrink-0 text-gray-400 far fa-chevron-right"></i>
                        )}
                      </div>
                    </li>
                  ))}
                </ol>
              )}

              {this.state.currentStep === 1 && (
                <>
                  <AppWrapperSubtitle>Выбор формы оплаты</AppWrapperSubtitle>
                  <AppWrapperList>
                    <ListCard
                      onClick={() => this.setChosenPaymentForm(PaymentForm.Manual)}
                      icon={<i className="fas fa-ruble-sign"></i>}
                    >
                      <span className="!text-[14px] cursor-pointer">
                        Определить сумму уплаты членского взноса за текущий период самостоятельно
                      </span>
                    </ListCard>
                    <ListCard
                      onClick={() => this.setChosenPaymentForm(PaymentForm.Month)}
                      icon={<i className="fas fa-calendar"></i>}
                    >
                      <span className="!text-[14px] cursor-pointer">
                        Оплатить членский взнос за установленный период
                      </span>
                    </ListCard>
                  </AppWrapperList>
                </>
              )}

              {this.state.currentStep === 2 && (
                <>
                  {this.state.chosenPaymentForm === PaymentForm.Month && (
                    <>
                      <AppWrapperSubtitle>Выбор периода уплаты членского взноса</AppWrapperSubtitle>

                      {!this.state.selectedPeriod && (
                        <AppWrapperList>
                          <ListCard onClick={() => this.setSelectedPeriod('month')}>
                            <span className="!text-[14px] cursor-pointer">за месяц</span>
                          </ListCard>
                          <ListCard onClick={() => this.setSelectedPeriod('quarter')}>
                            <span className="!text-[14px] cursor-pointer">за квартал</span>
                          </ListCard>
                          <ListCard onClick={() => this.setSelectedPeriod('year')}>
                            <span className="!text-[14px] cursor-pointer">за год</span>
                          </ListCard>
                        </AppWrapperList>
                      )}

                      {!!this.state.selectedPeriod && (
                        <button
                          className="w-full flex flex-row items-center justify-center gap-x-3 flex-nowrap text-[#9B99B1] uppercase text-[14px] leading-tight font-semibold py-3 border-2 border-[#9B99B1] rounded-lg"
                          aria-label="Назад"
                          style={{ borderRadius: '12px', background: 'rgba(255, 255, 255, 0.1)' }}
                          onClick={() => this.setSelectedPeriod(null)}
                        >
                          <span>
                            <i className="far fa-chevron-left"></i>
                          </span>
                          <span>Вернуться в предыдущее меню</span>
                        </button>
                      )}

                      {this.state.selectedPeriod === 'month' && (
                        <>
                          <Listbox value={me.state?.chosenPeriod?.month}>
                            {({ open }) => (
                              <>
                                <div className="relative mt-1">
                                  <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border border-gray-300 rounded-md shadow-sm cursor-default focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm">
                                    <span className="block truncate">
                                      {me.state.periods[me?.state?.chosenPeriod?.month - 1]
                                        ?.title || 'Выберите период уплаты'}
                                    </span>
                                    <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                      <i className="text-gray-400 fas fa-sort"></i>
                                    </span>
                                  </Listbox.Button>

                                  <Transition
                                    show={open}
                                    as={Fragment}
                                    leave="transition ease-in duration-100"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                  >
                                    <Listbox.Options className="absolute z-10 w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                                      {me.state.periods.map((_x, _index) => (
                                        <Listbox.Option
                                          key={_index}
                                          className={({ active }) =>
                                            this.classNames(
                                              active ? 'text-white bg-primary' : 'text-gray-900',
                                              'cursor-default select-none relative py-2 pl-3 pr-9'
                                            )
                                          }
                                          value={_x}
                                          onClick={() => this.periodOnSelect(_x, user)}
                                        >
                                          {({ selected, active }) => (
                                            <>
                                              <span
                                                className={this.classNames(
                                                  selected ? 'font-semibold' : 'font-normal',
                                                  'block truncate'
                                                )}
                                              >
                                                {_x.title}
                                              </span>

                                              {selected ? (
                                                <span
                                                  className={this.classNames(
                                                    active ? 'text-white' : 'text-primary',
                                                    'absolute inset-y-0 right-0 flex items-center pr-4'
                                                  )}
                                                >
                                                  <i className="fa-solid fa-check"></i>
                                                </span>
                                              ) : null}
                                            </>
                                          )}
                                        </Listbox.Option>
                                      ))}
                                    </Listbox.Options>
                                  </Transition>
                                </div>
                              </>
                            )}
                          </Listbox>
                        </>
                      )}

                      {this.state.selectedPeriod === 'quarter' && (
                        <>
                          <AppWrapperList>
                            <ListCard onClick={() => this.prepareQuarterPayment(1, 3)}>
                              <span className="!text-[14px] cursor-pointer">
                                за 1 квартал {new Date().getFullYear()} года
                              </span>
                            </ListCard>
                            <ListCard onClick={() => this.prepareQuarterPayment(4, 6)}>
                              <span className="!text-[14px] cursor-pointer">
                                за 2 квартал {new Date().getFullYear()} года
                              </span>
                            </ListCard>
                            <ListCard onClick={() => this.prepareQuarterPayment(7, 9)}>
                              <span className="!text-[14px] cursor-pointer">
                                за 3 квартал {new Date().getFullYear()} года
                              </span>
                            </ListCard>
                            <ListCard onClick={() => this.prepareQuarterPayment(10, 12)}>
                              <span className="!text-[14px] cursor-pointer">
                                за 4 квартал {new Date().getFullYear()} года
                              </span>
                            </ListCard>
                          </AppWrapperList>
                        </>
                      )}

                      {this.state.selectedPeriod === 'year' && (
                        <>
                          <AppWrapperList>
                            <ListCard onClick={() => this.prepareYearPayment(2025)}>
                              <span className="!text-[14px] cursor-pointer">за 2025 год</span>
                            </ListCard>
                          </AppWrapperList>
                        </>
                      )}
                    </>
                  )}

                  {this.state.chosenPaymentForm === PaymentForm.Manual && (
                    <>
                      <AppWrapperSubtitle>
                        Уплата членского взноса за текущий период в рамках{' '}
                        {new Date().getFullYear()}
                        &nbsp;года
                      </AppWrapperSubtitle>

                      <div>
                        <label htmlFor="amount" className="block text-sm font-medium text-gray-700">
                          Сумма уплаты членского взноса *
                        </label>
                        <div className="relative mt-1 rounded-lg shadow-sm">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <i className="text-gray-500 far fa-ruble-sign sm:text-sm"></i>
                          </div>
                          <input
                            type="number"
                            name="amount"
                            id="amount"
                            className="block w-full py-4 pr-12 border-gray-300 rounded-md focus:ring-primary focus:border-primary pl-7 sm:text-sm"
                            placeholder="0.00"
                            min={MIN_AMOUNT}
                            max={MAX_AMOUNT}
                            onChange={this.handleAmountChange}
                            value={this.state.amount}
                            step="0.01"
                          />
                        </div>
                      </div>
                      {!!this.state.amountError && (
                        <p className="text-red-500">{this.state.amountError}</p>
                      )}

                      <div>
                        <label
                          htmlFor="comment"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Комментарий (опционально)
                        </label>
                        <div className="relative mt-1 rounded-lg shadow-sm">
                          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                            <i className="text-gray-500 far fa-comment sm:text-sm"></i>
                          </div>
                          <input
                            type="text"
                            name="comment"
                            id="comment"
                            className="block w-full py-4 pl-8 pr-12 border-gray-300 rounded-md focus:ring-primary focus:border-primary sm:text-sm"
                            onChange={this.handleCommentChange}
                            value={this.state.comment}
                          />
                        </div>
                      </div>

                      <button
                        onClick={this.validateAmount}
                        className="w-full px-4 py-5 text-base font-semibold text-white bg-primary rounded-xl focus:outline-none focus:ring-primary focus:border-primary"
                      >
                        Продолжить
                      </button>
                    </>
                  )}
                </>
              )}

              {this.state.currentStep === 3 && (
                <>
                  {/*{JSON.stringify(this.state.chosenPeriod)}*/}
                  <AppWrapperSubtitle>
                    Уплата членского взноса за текущий период в рамках {new Date().getFullYear()}
                    &nbsp;года
                  </AppWrapperSubtitle>

                  <AppWrapperSubtitle>выбор метода оплаты</AppWrapperSubtitle>
                  <p className="p-4 text-2xl font-semibold text-gray-800 bg-gray-100 rounded-lg shadow-md">
                    Сумма к оплате составит: {(me.state?.chosenPeriod?.amount / 100.0).toFixed(2)}
                    &nbsp;
                    <i className="far fa-ruble-sign"></i>
                  </p>
                  {!me.state.chosenPeriod?.is_deposit && (
                    <p className="p-4 text-sm text-gray-700 bg-gray-100 rounded-lg shadow-md">
                      Для вашего региона ежемесячная сумма членского взноса составляет:{' '}
                      {(BASE_AMOUNT / 100).toFixed(2)}&nbsp;
                      <i className="far fa-ruble-sign"></i>
                    </p>
                  )}

                  <AppWrapperList>
                    <ListCard
                      onClick={() => this.methodOnSelect(false)}
                      icon={<i className="fas fa-money-check"></i>}
                    >
                      оплатить банковской картой
                    </ListCard>
                    <ListCard
                      onClick={() => this.methodOnSelect(true)}
                      icon={<img src="/img/sbp.svg" alt="sbp" loading="lazy" />}
                    >
                      система быстрых платежей
                    </ListCard>
                  </AppWrapperList>
                  {this.state.additional && (
                    <>
                      <Link to="/guarantee">
                        <LinkCard icon={<i className="fas fa-shield-alt"></i>}>
                          Гарантии безопасности платежей
                        </LinkCard>
                      </Link>

                      <Link to="/refund">
                        <LinkCard icon={<i className="fas fa-question-circle"></i>}>
                          Условия возврата
                        </LinkCard>
                      </Link>
                    </>
                  )}
                </>
              )}
              <ToastContainer />
            </AppWrapper>
          </>
        )}
      </UserContext.Consumer>
    )
  }
}

export default withUserContext(PaymentView)
